import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { NotifierService } from 'angular-notifier';
import { BaseComponent } from 'src/app/shared/components/base/base.component';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { Message } from 'src/app/core/class/message';

@Component({
  selector: 'app-menu-export-report',
  templateUrl: './menu-export-report.component.html',
  styleUrls: ['./menu-export-report.component.scss']
})
export class MenuExportReportComponent extends BaseComponent implements OnInit {

  constructor(
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService
  ) {
    super(commonService, message);
    this.notifier = notifier;
  }

  ngOnInit() {
  }

}
